/**
 * src/components/NoData.js
 *
 * Shared empty-state component used across the application.
 */

import React from "react";
import { Inbox } from "lucide-react";

export default function NoData({ title, description, icon: Icon = Inbox, children }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="w-14 h-14 rounded-2xl bg-gray-100 dark:bg-neutral-800 flex items-center justify-center mb-4">
        <Icon className="w-7 h-7 text-gray-400 dark:text-gray-500" />
      </div>
      {title && (
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-1">{title}</h3>
      )}
      {description && (
        <p className="text-sm text-gray-500 dark:text-gray-400 max-w-xs">{description}</p>
      )}
      {children && <div className="mt-4">{children}</div>}
    </div>
  );
}
